import { ApiProperty } from "@nestjs/swagger";

export class ConsumtionReportRequest {
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    itemId?:number;
    @ApiProperty()
    consumedFromDate?:any;
    @ApiProperty()
    consumedToDate?:any;
    unitId?:number;
    @ApiProperty()
    createdDate?:Date;
    @ApiProperty()
    itemCategoryId?:number;
    @ApiProperty()
    itemSubCategoryId?:number;
    @ApiProperty()
    uomId?:number;

    @ApiProperty()
    indentFromDate?:string

    @ApiProperty()
    indentToDate?:string

    @ApiProperty()
    createdFromDate?:string

    @ApiProperty()
    createdToDate?:string
    @ApiProperty()
    departmentId?:number;

    constructor(saleOrderId: number,itemId:number,consumedFromDate?:any,consumedToDate?:any,unitId?:number,createdDate?:Date,itemSubCategoryId?:number,itemCategoryId?:number, uomId?:number,indentFromDate?:string,indentToDate?:string,createdFromDate?:string,createdToDate?:string,departmentId?:number
    ) {
        this.saleOrderId = saleOrderId;
        this.itemId=itemId;
        this.consumedFromDate=consumedFromDate;
        this.consumedToDate=consumedToDate;
        this.unitId=unitId;
        this.createdDate=createdDate;
        this.itemCategoryId=itemCategoryId;
        this.itemSubCategoryId=itemSubCategoryId;
        this. uomId=uomId;
        this.indentFromDate = indentFromDate
        this.indentToDate = indentToDate
        this.createdFromDate = createdFromDate
        this.createdToDate = createdToDate
        this.departmentId=departmentId
    }

}